import { formatMoney } from '../../lib/formatters.ts'
import type { EarlyPayOffer, MoneyFig, PaymentItem } from '../../api/cashReport'
import CrIcon from './CrIcon.tsx'

type Props = {
  items: PaymentItem[]
  total?: MoneyFig | null
  offer?: EarlyPayOffer | null
  onOpen?: (projectId: number, focus?: string | null) => void
}

export default function PaymentsList({ items, total, offer, onOpen }: Props) {
  return (
    <section className="cr-panel" data-testid="cr-payments">
      <header className="cr-info-head">
        <div className="cr-eyebrow"><CrIcon name="cash-out" /> Money going</div>
        <h3><span className="cr-money">{total?.formatted || formatMoney((total?.amount ?? 0))}</span> in 30 days</h3>
        <p>Approved vendor bills, job costs, payroll, overhead, and assumptions.</p>
      </header>
      {items.map((item, i) => (
        <div
          key={`${item.source_type}-${item.source_id ?? i}`}
          className="cr-source-row"
          data-testid={`cr-payment-${item.source_type}-${item.source_id ?? 'unset'}`}
        >
          <div className="cr-source-main">
            <button
              type="button"
              onClick={() => item.project_id != null && onOpen?.(item.project_id, item.focus)}
            >
              {item.source_type === 'job_cost' ? <CrIcon name="vendor-bill" /> : null}
              {item.label || item.source_type}
            </button>
            <span>Open source</span>
          </div>
          {item.unset ? (
            <span className="cr-source-amount cr-muted">—</span>
          ) : (
            <button
              type="button"
              className="cr-source-amount"
              onClick={() => item.project_id != null && onOpen?.(item.project_id, item.focus)}
            >
              {item.amount?.formatted || formatMoney((item.amount_cents || 0) / 100)}
            </button>
          )}
        </div>
      ))}
      {offer?.eligible ? (
        <div className="cr-offer" data-testid="cr-early-pay">
          <b>Early-pay ladder</b>
          <p>Every projected week stays at or above the cushion after paying early.</p>
          <div className="cr-ladder">
            {(offer.ladder || []).map((rung) => (
              <span key={rung.days}>
                <b>{formatMoney((rung.save_cents || 0) / 100)}</b>
                {rung.label}
              </span>
            ))}
          </div>
        </div>
      ) : null}
    </section>
  )
}
